import { useQueryGrid } from '@gogame/query';

import { loadConceptFamiliesGrid } from 'scenes/Gallery/GalleryPage/ConceptFamilies/sources/conceptFamilies';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

import { useSearchParamsWithType } from '../../utils/useSearchParamsWithType';
import { grid } from './queryKeyFactory';

export const useConceptFamiliesGrid = (params) => {
  const { isAllowConceptFamilies } = useGalleryPermissions();
  const searchParamsWithType = useSearchParamsWithType(params);
  return useQueryGrid(
    grid(searchParamsWithType),
    (_, { signal }) =>
      loadConceptFamiliesGrid(searchParamsWithType, { signal }),
    {
      enabled: isAllowConceptFamilies,
    }
  );
};
